import Script from 'next/script'
import { type SbBaseBlockProps } from '@/services/storyblok/storyblok'
export type CustomSchemaOrgProps = SbBaseBlockProps<{
  schema: string
}>

export function CustomSchemaOrg({ blok }: CustomSchemaOrgProps) {
  return (
    <Script id={blok._uid} type="application/ld+json">
      {blok.schema}
    </Script>
  )
}
